module.exports = __webpack_public_path__ + "r-v3/img/camera_off.48b2f375.svg";